/* eslint-disable no-undef */
// Read runtime-injected variables (from deployment environment) and override compile-time variables
export default { ...process.env, ...window.env || {} };
